export const css = {
    root: '_12yR4Zxn',
    pressed: '_25bT9jgN',
    disabled: '_2g1EhYDx',
    label: '_18Q0dUhR',
    ' _key': 'ascm-theme/dojo/button'
};
export default css;
